/* Kopfbereich des Weissblau-Themes: Aufklapp-Navigation, mobiles Schubmenue, Suchpanel.
 *
 * Eigene Umsetzung, keine Uebernahme aus Flux - eigene Element- und Klassennamen.
 *
 * Was hier bewusst so ist (Quellen: docs/relaunch):
 * - Der Scroll-Handler liest KEINE Geometrie. Er fragt nur window.scrollY ab und schaltet eine
 *   layoutneutrale Klasse. Im alten Theme aenderte der Kompaktzustand Hoehe und Polsterung des
 *   Kopfes; das verschob den Inhalt, loeste neue Scroll-Ereignisse aus und lief ohne Hysterese in
 *   eine Dauerschleife. Deshalb auch die beiden Schwellen (an bei 12 px, aus bei 4 px).
 * - Der Listener haengt im Capture-Modus am Dokument: in eingebetteten Vorschauen scrollt nicht
 *   immer das window selbst, dann kaemen am window keine Ereignisse an.
 * - Kein requestAnimationFrame fuers Oeffnen/Schliessen: in Hintergrund-Tabs wird rAF gedrosselt,
 *   Overlays hingen dann halb offen. Wo ein Reflow gebraucht wird, wird er erzwungen (08 D1).
 * - Das Aufklapp-Panel ist immer links am Menuepunkt verankert und nur zum Fensterrand hin
 *   begrenzt. Rechts verankert wuchs es nach links, sobald die dritte Spalte erschien, und sprang.
 * - Die Navigationszeile hat keine Pfeile und keinen Ueberlauf-Test mehr: sie passt ab 1280 px
 *   immer in eine Zeile, die Schrift waechst per CSS mit (Entscheidung 18.09.2026).
 */

/* Zeitsperre der Formulare (Roadmap 7.59, mhsys kundeninhalte_zeit_ok()): ein signierter Zeitstempel von mhsys statt einer
   Wartezeit, die der Browser selbst angibt (_dauer liess sich faelschen). Jedes Formular, das eine Mail, ein Ticket oder Daten
   ausloest, ruft beim Oeffnen mhsysStempel.vor() und beim Absenden mhsysStempel.mit(rumpf).then(senden). mit() haengt _stempel
   an und wartet notfalls, bis der Stempel alt genug ist - wer schneller als 3 s abschickt, wartet still statt eine Meldung zu
   sehen. Holt hoechstens einen Stempel je sechs Stunden und Seite; schlaegt das Holen fehl, geht der Rumpf ohne Stempel raus
   (mhsys antwortet dann wie bisher mit "schnell"). Reine Zaehler (Suche, Handyleiste, Ausverkauft, Finder) brauchen das nicht. */
window.mhsysStempel = window.mhsysStempel || (() => {
  'use strict';
  const MINDEST = 3000;
  const NEU_NACH = 6 * 3600 * 1000;
  let laufend = null;
  const holen = () => {
    if (laufend && Date.now() - laufend.seit < NEU_NACH) return laufend.p;
    const eintrag = { seit: Date.now(), p: null };
    eintrag.p = fetch('/apps/kunde?bereich=stempel', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => (d && d.ok && typeof d.stempel === 'string' ? { s: d.stempel, da: Date.now() } : null))
      .catch(() => null)
      .then((x) => { if (!x && laufend === eintrag) laufend = null; return x; });
    laufend = eintrag;
    return eintrag.p;
  };
  return {
    vor: () => { holen(); },
    mit: (rumpf, mindestMs) => holen().then((x) => {
      if (!x) return rumpf;
      rumpf._stempel = x.s;
      const warten = (mindestMs || MINDEST) + 1000 - (Date.now() - x.da);
      return warten > 0 ? new Promise((fertig) => setTimeout(() => fertig(rumpf), warten)) : rumpf;
    }),
  };
})();

(() => {
  'use strict';

  const SCHWELLE_AN = 12;
  const SCHWELLE_AUS = 4;
  /* Ueber dem Hero wechselte der Kopf bis 28.09.2026 auch seine Hoehe (die Luft oben und unten fiel weg,
     40 px) - daher die weit auseinanderliegenden Grenzen gegen ein Aufschaukeln (08 E11). Seit Roadmap 5.5
     Paket B aendert der Kompaktzustand nur Gemaltes (mhsys-weissblau.css); die Grenzen bleiben, schaden nicht. */
  const SCHWELLE_AN_HERO = 140;
  const SCHWELLE_AUS_HERO = 60;
  /* Maus verlaesst Menuepunkt oder Panel: so lange bleibt es noch offen */
  const SCHLIESS_VERZOEGERUNG = 220;
  /* Wechsel der Flyout-Spalte beim Ueberfahren einer anderen Untergruppe */
  const FLYOUT_VERZOEGERUNG = 140;

  /* ------------------------------------------------------------- Fokusfalle */
  const FOKUSSIERBAR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* Arbeit, die nicht vor dem ersten Bild noetig ist, danach erledigen (INP, 18.09.2026): Scroll-Sperre
     (overflow am Dokument = Layout der ganzen Seite), Scrollposition, Fokus. requestAnimationFrame plus
     setTimeout 0 heisst "nach dem naechsten Zeichnen". rAF laeuft in Hintergrund-Tabs gedrosselt (08 D1) -
     deshalb der zweite Weg ueber einen Zeitgeber, wer zuerst kommt, gewinnt. */
  function nachDemBild(fn) {
    let erledigt = false;
    const los = () => {
      if (erledigt) return;
      erledigt = true;
      fn();
    };
    requestAnimationFrame(() => setTimeout(los, 0));
    setTimeout(los, 120);
  }

  /* Die Scroll-Sperre faellt erst nach dem naechsten Bild: im Klick selbst liess das Entfernen von
     overflow: hidden am Dokument den Fokus zurueck auf den Knopf ein Layout der ganzen Seite erzwingen
     (53 ms bei CPU x 4). Ist inzwischen wieder ein Overlay offen, bleibt sie. */
  function scrollSperreLoesen() {
    nachDemBild(() => {
      /* Auch ein Overlay aus assets/mhsys-popup.js (Kontakt aus dem Konto-Menue: es oeffnet im selben Klick, der das
         Menue schliesst) haelt die Sperre selbst */
      if (document.querySelector('.mhsys-menue.is-offen, .mhsys-suche.is-offen, .mhsys-konto.is-offen.is-bogen, .mhsys-popup:not([hidden])')) return;
      document.documentElement.classList.remove('mhsys-overlay-offen');
    });
  }

  function fokusFalle(behaelter, ausloeser, ohneFokus) {
    const beiTaste = (e) => {
      if (e.key !== 'Tab') return;
      const ziele = [...behaelter.querySelectorAll(FOKUSSIERBAR)].filter((el) => el.offsetParent !== null && !el.closest('[inert]'));
      if (!ziele.length) return;
      const erstes = ziele[0];
      const letztes = ziele[ziele.length - 1];
      if (e.shiftKey && document.activeElement === erstes) {
        e.preventDefault();
        letztes.focus();
      } else if (!e.shiftKey && document.activeElement === letztes) {
        e.preventDefault();
        erstes.focus();
      }
    };
    behaelter.addEventListener('keydown', beiTaste);
    if (!ohneFokus) behaelter.focus({ preventScroll: true });
    return (ohneRueckgabe) => {
      behaelter.removeEventListener('keydown', beiTaste);
      if (!ohneRueckgabe && ausloeser && ausloeser.focus) ausloeser.focus();
    };
  }

  /* ------------------------------------------------------------------- Kopf */
  /* Tipps im Handy-Menue an mhsys melden (Inhaber 29.10.2026, "so umbauen mit Zaehlung"; Suchfeld oben dazu am selben
     Abend): ueber denselben Weg wie die Handyleiste (mhsys Ort "menue", docs/module/handyleiste_tipps.md) -
     POST /apps/kunde?bereich=leiste {ort, satz, knopf, text, _dauer}. keepalive: ein Link verlaesst die Seite. Kein Kunde,
     keine IP, kein Cookie; Fehler bleiben still. */
  const menueSlug = (t) =>
    String(t || '')
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 40)
      .replace(/-+$/, '');
  function shopTippMelden(ort, satz, knopf, text) {
    knopf = menueSlug(knopf);
    if (!knopf || (window.Shopify && window.Shopify.designMode)) return;
    fetch('/apps/kunde?bereich=leiste', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ort, satz, knopf, text: String(text || '').replace(/\s+/g, ' ').trim().slice(0, 40), _dauer: Math.round(performance.now()) }),
      credentials: 'same-origin',
      keepalive: true,
    }).catch(() => {});
  }
  const menueTippMelden = (satz, knopf, text) => shopTippMelden('menue', satz, knopf, text);
  /* Die Suche wurde ueber das Suchfeld im Handy-Menue geoeffnet: MhsysSuche.auf() uebernimmt das und meldet dann, ob
     ein Treffer gewaehlt oder abgeschickt wurde */
  let sucheAusMenue = false;

  /* Shop-Klicks (Inhaber 29.10.2026: "alles sofort einbauen, was dir einfaellt, auch Klicks, auch Ankuendigungsleiste").
     Ein Horcher am Dokument (Capture, damit auch Knoepfe zaehlen, deren eigener Horcher die Weitergabe stoppt), dazu
     "change" fuer Filter, Sortierung und Varianten und ein Beobachter nur am Warenkorb-Element - beim Laden wird nichts
     gesendet, ausser einmal auf der 404-Seite. Was gemeldet wird, ist nie ein einzelnes Produkt, sondern Abschnitt, Stelle
     oder Stufe (mhsys HANDYLEISTE_ORT_SAETZE, docs/module/handyleiste_tipps.md). */
  function shopKlicksZaehlen() {
    if (document.documentElement.dataset.mhsysKlicks) return;
    document.documentElement.dataset.mhsysKlicks = '1';
    const kurz = (t) => String(t || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    const pfadEnde = (a) => (a.getAttribute('href') || '').split(/[?#]/)[0].replace(/\/+$/, '').split('/').pop() || 'start';
    const istProdukt = !!document.querySelector('[data-mhsys-produkt-seite]');
    const istStart = window.location.pathname === '/' || window.location.pathname === (window.Shopify && window.Shopify.routes && window.Shopify.routes.root);
    const ist404 = !!document.querySelector('.mhsys-404__berge');
    const abschnitt = (el) => {
      const sec = el.closest('.shopify-section');
      if (!sec) return null;
      const id = (sec.id || '').replace(/^shopify-section-/, '').split('__').pop();
      const h = sec.querySelector('h1, h2, h3');
      return [id, h ? h.textContent : id];
    };
    /* Warenwert-Stufe aus dem Fortschritt zur Versandgrenze in der Schublade (snippets/mhsys-warenkorb.liquid) */
    const wertStufe = () => {
      const p = document.querySelector('mhsys-warenkorb [role="progressbar"][aria-valuenow]');
      if (!p) return null;
      const n = parseInt(p.getAttribute('aria-valuenow'), 10) || 0;
      if (n >= 100) return ['frei', 'versandkostenfrei'];
      const st = n < 25 ? '0-24' : n < 50 ? '25-49' : n < 75 ? '50-74' : '75-99';
      return ['stufe-' + st, st + ' % der Versandgrenze'];
    };
    let poGezaehlt = false;

    if (ist404) shopTippMelden('fehlerseite', 'aufruf', 'aufruf', 'Seite nicht gefunden');

    /* Warenkorb-Schublade: Oeffnen (ueber Symbol/Knopf oder nach dem Einlegen) und Schliessen, Warenwert kurz danach */
    const wk = document.querySelector('mhsys-warenkorb:not([data-seite])');
    if (wk && 'MutationObserver' in window) {
      let offen = wk.classList.contains('is-offen');
      let letzterKlick = 0;
      /* Ein Klick zum Einlegen zaehlt nicht als Oeffnen per Klick, auch wenn die Antwort schnell kommt */
      document.addEventListener('click', (e) => {
        const einlegen = e.target instanceof Element && e.target.closest('[data-mhsys-kaufknopf], form[action*="/cart/add"], [data-wk-empf-dazu], .shopify-payment-button');
        letzterKlick = einlegen ? 0 : Date.now();
      }, true);
      new MutationObserver(() => {
        const jetzt = wk.classList.contains('is-offen');
        if (jetzt === offen) return;
        offen = jetzt;
        if (jetzt) {
          /* Das Symbol oeffnet sofort; nach "In den Warenkorb" oeffnet sie erst mit der Antwort des Shops (> 0,6 s) */
          const ueberKlick = Date.now() - letzterKlick < 600;
          shopTippMelden('warenkorb', 'schublade', ueberKlick ? 'auf-klick' : 'auf-einlegen', ueberKlick ? 'geöffnet per Klick' : 'geöffnet nach dem Einlegen');
          setTimeout(() => { const w = wertStufe(); if (w) shopTippMelden('warenkorb', 'wert-auf', w[0], w[1]); }, 1500);
        } else {
          shopTippMelden('warenkorb', 'schublade', 'zu', 'geschlossen');
        }
      }).observe(wk, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('click', (e) => {
      const el = e.target.closest('a, button, input[type="submit"], [role="button"], summary');
      if (!el) return;

      /* Warenkorb (Schublade und /cart) */
      if (el.closest('mhsys-warenkorb')) {
        if (el.matches('[name="checkout"]')) {
          const w = wertStufe() || ['unbekannt', 'unbekannt'];
          shopTippMelden('warenkorb', 'kasse', w[0], w[1]);
          return;
        }
        const AKTION = [['[data-wk-entfernen]', 'entfernt', 'Artikel entfernt'], ['[data-wk-plus]', 'plus', 'Menge +'], ['[data-wk-minus]', 'minus', 'Menge −'],
          ['[data-wk-express]', 'express', 'Express'], ['[data-wk-termin-oeffnen]', 'wunschtermin', 'Wunschtermin'],
          ['[data-mhsys-grusskarten-oeffnen]', 'grusskarte', 'Grußkarte'], ['[data-mhsys-gustl-oeffnen]', 'gustl', 'Gustl'],
          ['[data-wk-empf-dazu]', 'empfehlung', 'Empfehlung dazu'], ['.mhsys-wk__weiter', 'weiter', 'Weiter einkaufen'],
          ['[data-wk-zuletzt] a', 'zuletzt', 'Zuletzt angesehen'], ['a[href*="/products/"]', 'produkt', 'Produkt angetippt']];
        for (const [sel, knopf, text] of AKTION) if (el.matches(sel)) { shopTippMelden('warenkorb', 'aktion', knopf, text); return; }
        return;
      }

      /* Ankuendigungsleiste (sections/mhsys-infoleiste.liquid) */
      if (el.matches('.mhsysinfo-bar, .mhsysinfo-bar *') || el.closest('.mhsysinfo-bar')) {
        const a = el.closest('.mhsysinfo-bar') || el;
        shopTippMelden('ankuendigung', 'leiste', kurz(a.textContent), a.textContent);
        return;
      }

      /* Kopf: Symbole, Navigation am Rechner, Lupe */
      if (el.closest('.mhsys-kopf') && !el.closest('[data-mhsys-menue], [data-mhsys-suche]')) {
        if (el.matches('[data-mhsys-suche-auf]')) { if (!sucheAusMenue) shopTippMelden('kopf', 'lupe', 'auf', 'Lupe angetippt'); return; }
        if (el.closest('[data-mhsys-navi]')) {
          let li = el.closest('li');
          while (li && li.parentElement && li.parentElement.closest('li') && li.parentElement.closest('[data-mhsys-navi]')) li = li.parentElement.closest('li');
          const oben = li && li.querySelector('a, button');
          const name = oben ? oben.textContent : el.textContent;
          shopTippMelden('kopf', 'navi', kurz(name), name);
          return;
        }
        let knopf = '';
        if (el.matches('.mhsys-kopf__logo, .mhsys-kopf__logo *') || el.closest('.mhsys-kopf__logo')) knopf = 'logo';
        else if (el.matches('[data-mhsys-konto-auf]')) knopf = 'konto';
        else if (el.matches('[data-mhsys-menue-auf]')) knopf = 'menue';
        else if (el.matches('a[href*="merkliste"]')) knopf = 'merkliste';
        else if (el.matches('a[href$="/cart"], [data-mhsys-wk-auf], [aria-controls*="warenkorb"]')) knopf = 'warenkorb';
        if (knopf) shopTippMelden('kopf', 'symbol', knopf, { logo: 'Logo', konto: 'Konto', menue: 'Menü', merkliste: 'Merkliste', warenkorb: 'Warenkorb' }[knopf]);
        return;
      }

      /* Fuss */
      if (el.closest('.mhsys-fuss')) {
        if (el.closest('[data-mhsys-nl-form]') && el.matches('button, [type="submit"]')) { shopTippMelden('fuss', 'newsletter', 'senden', 'Anmelden gedrückt'); return; }
        if (el.tagName === 'A') shopTippMelden('fuss', 'link', pfadEnde(el), el.textContent);
        return;
      }

      /* 404-Seite */
      if (ist404 && el.tagName === 'A') { shopTippMelden('fehlerseite', 'link', pfadEnde(el), el.textContent); return; }

      /* Kollektion und Suchseite */
      const koll = el.closest('[data-mhsys-kollektion]');
      if (koll) {
        if (el.matches('[data-mhsys-mehr]')) { shopTippMelden('sortiment', 'mehr', 'mehr-laden', 'Mehr laden'); return; }
        if (el.matches('[data-merk-herz]') || el.closest('[data-merk-herz]')) { shopTippMelden('sortiment', 'merken', 'herz', 'Herz auf der Kachel'); return; }
        const kachel = el.closest('.mhsys-kachel');
        if (kachel && el.matches('a[href*="/products/"]')) {
          const alle = Array.from(koll.querySelectorAll('.mhsys-kachel'));
          const n = alle.indexOf(kachel) + 1;
          const st = n <= 4 ? '1-4' : n <= 12 ? '5-12' : n <= 24 ? '13-24' : n <= 48 ? '25-48' : '49-plus';
          shopTippMelden('sortiment', 'kachel', 'stelle-' + st, 'Stelle ' + st);
        }
        return;
      }

      /* Produktseite */
      if (istProdukt && el.closest('[data-mhsys-produkt-seite], .shopify-section')) {
        const ELEMENT = [['[data-mhsys-groessentabelle]', 'groessentabelle', 'Größentabelle'], ['[data-mhsys-kuerzen-knopf]', 'mehr-lesen', 'Mehr lesen'],
          ['[data-mhsys-bew-oeffnen], [data-mhsys-bew-mehr]', 'bewertungen', 'Bewertungen'], ['[data-mhsys-pfr-oeffnen]', 'fragen', 'Produktfragen'],
          ['[data-mhsys-teilen], [data-mhsys-teilen-kopieren]', 'teilen', 'Teilen'], ['[data-merk-herz]', 'merken', 'Merken (Herz)']];
        for (const [sel, knopf, text] of ELEMENT) if (el.matches(sel) || el.closest(sel)) { shopTippMelden('produktseite', 'element', knopf, text); return; }
        const GALERIE = [['[data-mhsys-galerie-thumb]', 'vorschaubild', 'Vorschaubild'], ['[data-mhsys-galerie-punkt]', 'punkt', 'Punkt'],
          ['[data-mhsys-galerie-zoom]', 'zoom', 'Zoom'], ['[data-mhsys-vorschau-weiter], [data-mhsys-vorschau-zurueck]', 'blaettern', 'Blättern']];
        for (const [sel, knopf, text] of GALERIE) if (el.matches(sel) || el.closest(sel)) { shopTippMelden('produktseite', 'galerie', knopf, text); return; }
        if (el.matches('[data-mhsys-kaufknopf]') || el.closest('[data-mhsys-kaufknopf]')) { shopTippMelden('produktseite', 'kauf', 'warenkorb', 'In den Warenkorb'); return; }
        if (el.closest('.shopify-payment-button')) { shopTippMelden('produktseite', 'kauf', 'sofort', 'Sofort kaufen (Express)'); return; }
        if (el.closest('[data-mhsys-passt-dazu]') && el.matches('a, button')) { shopTippMelden('produktseite', 'empfehlung', 'passt-dazu', 'Passt dazu'); return; }
        if (el.closest('[data-mhsys-fbt]') && el.matches('a, button')) { shopTippMelden('produktseite', 'empfehlung', 'zusammen', 'Oft zusammen gekauft'); return; }
        return;
      }

      /* Startseite: welcher Abschnitt, beim Banner welche Folie */
      if (istStart && el.matches('a, button')) {
        const spur = el.closest('[data-mhsys-hero-spur]');
        if (spur && el.tagName === 'A') {
          const folie = Array.from(spur.children).find((k) => k.contains(el));
          const n = Array.from(spur.children).indexOf(folie) + 1;
          shopTippMelden('startseite', 'held', 'folie-' + n, 'Folie ' + n);
          return;
        }
        if (el.tagName !== 'A') return;
        const ab = abschnitt(el);
        if (ab) shopTippMelden('startseite', 'abschnitt', ab[0], ab[1]);
        return;
      }

      /* Spiele: Klick aus dem Spiel in den Shop */
      if (el.tagName === 'A' && /\/(products|collections)\//.test(el.getAttribute('href') || '')) {
        const sp = el.closest('.shopify-section[id*="theke"], .shopify-section[id*="spiel"], [data-mhsys-spiel]');
        if (sp) shopTippMelden('spiel', 'shop', (sp.id || 'spiel').split('__').pop(), document.title.split('–')[0]);
      }
    }, true);

    /* Filter, Sortierung (Kollektion/Suche) und Varianten, Express, Wunschtext (Produktseite) */
    document.addEventListener('change', (e) => {
      const f = e.target;
      if (!(f instanceof HTMLElement)) return;
      if (f.closest('[data-mhsys-kollektion]')) {
        if (f.matches('[data-mhsys-sort]')) { shopTippMelden('sortiment', 'sort', f.value, f.options && f.selectedIndex >= 0 ? f.options[f.selectedIndex].text : f.value); return; }
        if (f.closest('[data-mhsys-filterform]') && f.name) {
          const name = f.name.replace(/^filter\.(v|p)\.(option\.|m\.[a-z_]+\.)?/, '').replace(/\.(gte|lte)$/, '');
          shopTippMelden('sortiment', 'filter', name, name);
        }
        return;
      }
      if (istProdukt) {
        if (f.closest('[data-mhsys-variante-feld]')) shopTippMelden('produktseite', 'kauf', 'variante', 'Variante gewechselt');
        else if (f.closest('[data-mhsys-express]')) shopTippMelden('produktseite', 'element', 'express', 'Express angehakt');
      }
    }, true);
    document.addEventListener('focusin', (e) => {
      if (poGezaehlt || !istProdukt || !(e.target instanceof HTMLElement) || !e.target.closest('[data-mhsys-po-feld]')) return;
      poGezaehlt = true;
      shopTippMelden('produktseite', 'element', 'wunschtext', 'Wunschtext angefangen');
    }, true);
  }

  class MhsysKopf {
    constructor(wurzel) {
      this.kopf = wurzel;
      this.navibereich = wurzel.querySelector('[data-mhsys-navibereich]');
      this.navi = wurzel.querySelector('[data-mhsys-navi]');
      this.punkte = [...wurzel.querySelectorAll('[data-mhsys-punkt]')];
      this.panels = [...wurzel.querySelectorAll('[data-mhsys-panel]')];
      this.offen = null;
      this.kompakt = false;

      this.punkteVerbinden();
      this.scrollenVerbinden();

      document.addEventListener('pointerdown', (e) => {
        if (!this.offen) return;
        if (this.kopf.contains(e.target)) return;
        this.panelZu();
      }, true);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.offen) this.panelZu();
      });
    }

    /* ---- Aufklapp-Panels ---- */

    /* Maus: oeffnen beim Ueberfahren, schliessen erst nach SCHLIESS_VERZOEGERUNG. Zwischen
       Menuepunkt und Panel liegen Innenabstand und Berglinie (~24 px). Ohne Verzoegerung und
       Bruecke ging das Panel dort zu, man kam mit der Maus nicht hinein (18.09.2026).
       Die Bruecke ist ein unsichtbarer Streifen ueber dem Panel (::before, Hoehe aus
       --mhsys-bruecke), die Verzoegerung faengt schraege Wege und kurze Aussetzer ab.
       Nur pointerType "mouse": auf Touch loest das Antippen sonst mouseenter UND click aus,
       das Panel ging auf und sofort wieder zu. */
    punkteVerbinden() {
      this.punkte.forEach((punkt) => {
        const nr = punkt.dataset.mhsysPunkt;
        const panel = this.panels.find((p) => p.dataset.mhsysPanel === nr);
        if (!panel) return;

        punkt.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse') return;
          this.schliessenAbbrechen();
          this.panelAuf(punkt, panel, true);
        });
        punkt.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') this.schliessenPlanen();
        });
        /* Zwei Formen: ein <button> (Punkt ohne eigene Seite) schaltet selbst; ein Paar aus Link und
           Pfeil-Knopf (Punkt mit eigener Seite) - der Link navigiert, der Knopf schaltet. */
        const knopf = punkt.matches('button') ? punkt : punkt.querySelector('[data-mhsys-punkt-knopf]');
        const link = punkt.querySelector('[data-mhsys-punkt-link]');

        /* Tastatur (h10, 18.09.2026): nicht mehr beim blossen Fokussieren oeffnen - dann schloss Enter auf dem
           Pfeil-Knopf das Panel sofort wieder, und Tab lief am Panel vorbei (es steht im HTML hinter allen
           Menuepunkten). Jetzt Aufklapp-Muster: Enter/Leertaste/Pfeil runter oeffnet, Tab fuehrt hinein. */
        if (knopf) {
          knopf.addEventListener('keydown', (e) => {
            const istOffen = this.offen && this.offen.panel === panel;
            /* Enter/Leertaste hier selbst schalten; preventDefault unterdrueckt den Klick, den der Browser
               sonst noch ausloest - so schaltet ein Tastendruck genau einmal */
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if (istOffen) this.panelZu();
              else this.panelAuf(punkt, panel);
            } else if (e.key === 'ArrowDown') {
              e.preventDefault();
              this.panelAuf(punkt, panel);
              this.panelFolge(panel)[0]?.focus();
            } else if (e.key === 'Tab' && !e.shiftKey && istOffen) {
              const erster = this.panelFolge(panel)[0];
              if (erster) {
                e.preventDefault();
                erster.focus();
              }
            }
          });
        }
        panel.addEventListener('keydown', (e) => this.panelTaste(e, punkt, panel));
        if (knopf) {
          knopf.addEventListener('click', (e) => {
            e.preventDefault();
            const istOffen = this.offen && this.offen.panel === panel;
            /* Per Maus schon beim Ueberfahren geoeffnet: der Klick soll es nicht gleich wieder zuklappen */
            if (istOffen && e.pointerType === 'mouse' && this.offen.perMaus) return;
            if (istOffen) this.panelZu();
            else this.panelAuf(punkt, panel);
          });
        }
        if (link) {
          /* Pfeil runter auf dem Link: Panel auf und in den ersten Eintrag springen */
          link.addEventListener('keydown', (e) => {
            if (e.key !== 'ArrowDown') return;
            e.preventDefault();
            this.panelAuf(punkt, panel);
            const erster = panel.querySelector('a[href]');
            if (erster) erster.focus();
          });
        }

        panel.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.schliessenAbbrechen();
        });
        panel.addEventListener('pointerleave', (e) => {
          if (e.pointerType === 'mouse') this.schliessenPlanen();
        });
        this.flyoutVerbinden(panel);
      });

      /* Tastatur: verlaesst der Fokus den Kopf ganz, geht das Panel zu */
      this.kopf.addEventListener('focusout', (e) => {
        if (!this.offen) return;
        if (e.relatedTarget && this.kopf.contains(e.relatedTarget)) return;
        this.panelZu();
      });
    }

    /* Tab-Reihenfolge im Panel: jede Untergruppe, und direkt hinter einer Untergruppe mit dritter Ebene
       deren Links im Flyout (sofern es gerade fuer sie offen ist). Im HTML steht das Flyout hinter allen
       Untergruppen - ohne diese Folge kaeme man per Tab nur an die dritte Ebene der letzten Gruppe. */
    panelFolge(panel) {
      const folge = [];
      panel.querySelectorAll('.mhsys-kopf__gruppe').forEach((gruppe) => {
        folge.push(gruppe);
        const nr = gruppe.dataset.mhsysGruppe;
        if (nr === undefined) return;
        const spalte = panel.querySelector(`[data-mhsys-flyout-gruppe="${nr}"]`);
        if (spalte && !spalte.hidden && !spalte.closest('[hidden]')) {
          spalte.querySelectorAll('a[href]').forEach((a) => folge.push(a));
        }
      });
      return folge;
    }

    panelTaste(e, punkt, panel) {
      const schalter = this.schalter(punkt);
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.panelZu();
        schalter.focus();
        return;
      }
      if (e.key !== 'Tab') return;
      const folge = this.panelFolge(panel);
      const i = folge.indexOf(document.activeElement);
      if (i === -1) return;
      e.preventDefault();
      if (e.shiftKey) {
        (folge[i - 1] || schalter).focus();
        return;
      }
      if (folge[i + 1]) {
        folge[i + 1].focus();
        return;
      }
      /* Hinter dem letzten Eintrag: Panel zu, weiter zum naechsten Element nach dem Menuepunkt */
      const alle = [...this.kopf.querySelectorAll('a[href], button:not([disabled])')].filter(
        (el) => el.offsetParent !== null && !panel.contains(el)
      );
      const naechstes = alle[alle.indexOf(schalter) + 1];
      this.panelZu();
      if (naechstes) naechstes.focus();
    }

    schliessenPlanen() {
      this.schliessenAbbrechen();
      this.schliessTimer = setTimeout(() => this.panelZu(), SCHLIESS_VERZOEGERUNG);
    }

    schliessenAbbrechen() {
      clearTimeout(this.schliessTimer);
    }

    panelAuf(punkt, panel, perMaus = false) {
      if (this.offen && this.offen.panel === panel) return;
      this.panelZu();

      /* Geometrie wird hier gelesen - beim Oeffnen, nicht im Scroll-Handler. */
      const rk = this.kopf.getBoundingClientRect();
      const rp = punkt.getBoundingClientRect();
      const vonLinks = rp.left - rk.left;

      panel.hidden = false;
      /* Links am Menuepunkt verankert, aber so, dass Panel und ein spaeter aufgehendes Flyout (liegt
         absolut rechts daneben, ~300 px) ins Fenster passen. Die Breite ist erst nach dem Einblenden
         messbar; lange Listen laufen mehrspaltig und machen das Panel breiter. */
      const flyoutPlatz = panel.querySelector('[data-mhsys-flyout]') ? 300 : 0;
      const maxLinks = Math.max(12, rk.width - panel.offsetWidth - flyoutPlatz - 12);
      panel.style.left = `${Math.min(Math.max(12, vonLinks), maxLinks)}px`;

      /* Bruecke: Abstand von der Unterkante des Menuepunkts bis zur Oberkante des Panels */
      const luecke = panel.getBoundingClientRect().top - rp.bottom;
      panel.style.setProperty('--mhsys-bruecke', `${Math.max(0, Math.ceil(luecke)) + 2}px`);

      this.schalter(punkt).setAttribute('aria-expanded', 'true');
      punkt.classList.add('is-offen');
      this.offen = { punkt, panel, perMaus };
    }

    panelZu() {
      this.schliessenAbbrechen();
      if (!this.offen) return;
      const { punkt, panel } = this.offen;
      panel.hidden = true;
      if (panel.mhsysFlyoutZu) panel.mhsysFlyoutZu();
      this.schalter(punkt).setAttribute('aria-expanded', 'false');
      punkt.classList.remove('is-offen');
      this.offen = null;
    }

    /* Das Element mit aria-expanded: der Punkt selbst (button) oder sein Pfeil-Knopf (Link-Paar) */
    schalter(punkt) {
      return punkt.matches('button') ? punkt : punkt.querySelector('[data-mhsys-punkt-knopf]') || punkt;
    }

    /* Dritte Ebene: das Panel geht ohne Flyout auf (so breit wie seine Spalte). Erst wenn die Maus
       auf einer Untergruppe mit dritter Ebene steht - oder der Fokus dort landet -, erscheint rechts
       daneben ihre Spalte. Das Flyout liegt absolut neben dem Panel: die Spalte verschiebt sich nicht
       und das Panel aendert seine Breite nicht (Wunsch des Inhabers, 18.09.2026; vorher war die erste
       Untergruppe vorgewaehlt und das Flyout stand sofort offen). */
    flyoutVerbinden(panel) {
      const flyout = panel.querySelector('[data-mhsys-flyout]');
      if (!flyout) return;
      const gruppen = [...panel.querySelectorAll('.mhsys-kopf__gruppe')];
      const spalten = [...flyout.querySelectorAll('[data-mhsys-flyout-gruppe]')];

      /* Absichtsverzoegerung: wer schraeg von einer Untergruppe ins Flyout faehrt, streift dabei die
         Untergruppen darunter. Umgeschaltet wird erst, wenn die Maus kurz auf einer Untergruppe
         bleibt; das Betreten des Flyouts bricht einen Wechsel ab. Steht noch kein Flyout offen,
         erscheint es sofort. */
      let wechselTimer;
      flyout.addEventListener('pointerenter', () => clearTimeout(wechselTimer));

      const zeigen = (gruppe) => {
        const nr = gruppe.dataset.mhsysGruppe;
        let getroffen = false;
        spalten.forEach((spalte) => {
          const passt = nr !== undefined && spalte.dataset.mhsysFlyoutGruppe === nr;
          spalte.hidden = !passt;
          if (passt) getroffen = true;
        });
        flyout.hidden = !getroffen;
        gruppen.forEach((g) => g.classList.toggle('is-aktiv', g === gruppe && getroffen));
      };

      gruppen.forEach((gruppe) => {
        gruppe.addEventListener('pointerenter', (e) => {
          clearTimeout(wechselTimer);
          if (e.pointerType !== 'mouse' || flyout.hidden) return zeigen(gruppe);
          wechselTimer = setTimeout(() => zeigen(gruppe), FLYOUT_VERZOEGERUNG);
        });
        gruppe.addEventListener('pointerleave', () => clearTimeout(wechselTimer));
        gruppe.addEventListener('focus', () => zeigen(gruppe));
      });

      /* Beim Schliessen des Panels zuruecksetzen, damit es beim naechsten Oeffnen wieder ohne Flyout
         aufgeht */
      panel.mhsysFlyoutZu = () => {
        clearTimeout(wechselTimer);
        flyout.hidden = true;
        spalten.forEach((spalte) => (spalte.hidden = true));
        gruppen.forEach((g) => g.classList.remove('is-aktiv'));
      };
    }

    /* ---- Kompaktzustand ---- */

    scrollenVerbinden() {
      const klassisch = this.kopf.classList.contains('mhsys-kopf--klassisch');
      const ueberhero = this.kopf.classList.contains('mhsys-kopf--ueberhero');
      if (!klassisch && !ueberhero) return;
      const an = ueberhero ? SCHWELLE_AN_HERO : SCHWELLE_AN;
      const aus = ueberhero ? SCHWELLE_AUS_HERO : SCHWELLE_AUS;
      /* Kopf weg beim Runterscrollen, zurueck beim Hochscrollen (Roadmap 1.78, Inhaber 08.10.2026, Idee 4): am Handy
         sitzen Suche, Konto, Merkliste und Korb oben, wo der Daumen schlecht hinkommt, und nehmen beim Lesen Platz.
         Nur eine Klasse am <html> (mhsys-kopf-weg); das CSS schiebt den Kopf per transform hinaus - keine Hoehe aendert
         sich, kein Layoutsprung. Hysterese: erst 40 px nach unten bzw. 30 px nach oben seit dem letzten Wendepunkt,
         sonst flackerte er bei jedem kleinen Wischen. Nie, solange ein Overlay, die Schublade oder das Menue offen ist. */
      const handy = window.matchMedia('(max-width: 749px)');
      const html = document.documentElement;
      let weg = false;
      let wende = 0;
      const wegPruefen = (y) => {
        const gesperrt = !handy.matches || this.offen || ['mhsys-overlay-offen', 'mhsys-wk-offen'].some((k) => html.classList.contains(k));
        let neu = weg;
        if (gesperrt || y < an + 60) {
          neu = false;
          wende = y;
        } else if (!weg) {
          if (y < wende) wende = y;
          else if (y - wende > 40) neu = true;
        } else {
          if (y > wende) wende = y;
          else if (wende - y > 30) neu = false;
        }
        if (neu !== weg) {
          weg = neu;
          wende = y;
          html.classList.toggle('mhsys-kopf-weg', weg);
        }
      };
      const pruefen = () => {
        /* Nur scrollY - kein Zugriff auf Layout, also kein Reflow */
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        wegPruefen(y);
        if (!this.kompakt && y > an) {
          this.kompakt = true;
          this.kopf.classList.add('is-kompakt');
          this.panelZu();
        } else if (this.kompakt && y < aus) {
          this.kompakt = false;
          this.kopf.classList.remove('is-kompakt');
        } else if (this.kompakt && this.offen) {
          this.panelZu();
        }
      };
      /* Nur das Scrollen der Seite zaehlt. Mit capture kommen auch die Scroll-Ereignisse jeder Spur an
         (Galerie, Slider) - die Galerie stupst beim Laden sanft an, und jedes dieser Ereignisse las scrollY
         und erzwang ein Layout (Shirt: 49-81 ms beim Laden). */
      document.addEventListener(
        'scroll',
        (e) => {
          if (e.target === document || e.target === document.documentElement) pruefen();
        },
        { capture: true, passive: true }
      );
      /* Der erste Blick erst nach dem ersten Bild: scrollY erzwingt waehrend des Ladens ein Layout der
         ganzen Seite (40-74 ms bei CPU x 4, Messung Fiete/Thor 18.09.2026). Danach ist das Layout ohnehin
         frisch und die Abfrage kostet nichts. Eine wiederhergestellte Scrollposition meldet sich zusaetzlich
         ueber das scroll-Ereignis. Nicht nachDemBild(): dessen Zeitgeber (120 ms) kaeme waehrend des Ladens
         oft VOR dem ersten Bild. Rueckfall fuer Hintergrund-Tabs (rAF gedrosselt, 08 D1) ist "load". */
      let geprueft = false;
      const erstesMal = () => {
        if (geprueft) return;
        geprueft = true;
        pruefen();
      };
      requestAnimationFrame(() => setTimeout(erstesMal, 0));
      window.addEventListener('load', erstesMal, { once: true });
    }
  }

  /* --------------------------------------------------------- Mobiles Menue */
  class MhsysMenue {
    constructor(wurzel) {
      this.menue = wurzel;
      this.panel = wurzel.querySelector('.mhsys-menue__panel');
      this.ziel = wurzel.querySelector('[data-mhsys-menue-liste]');
      this.geladen = false;

      document.querySelectorAll('[data-mhsys-menue-auf]').forEach((knopf) => {
        this.ausloeser = knopf;
        knopf.addEventListener('click', () => this.auf(knopf));
        /* Vorladen, sobald jemand das Menue anfasst - so ist die Liste beim Oeffnen da */
        const vorladen = () => this.laden();
        knopf.addEventListener('pointerenter', vorladen, { passive: true, once: true });
        knopf.addEventListener('touchstart', vorladen, { passive: true, once: true });
      });

      wurzel.addEventListener('click', (e) => {
        /* Suchfeld im Kopf des Menues (27.09.2026, vorher oben in der Liste): Menue zu, Vorschlagssuche des Kopfs
           auf - im selben Tipp, damit iOS die Tastatur oeffnet (der Fokus aufs Eingabefeld geschieht in
           MhsysSuche.auf) */
        if (e.target.closest('[data-mhsys-menue-suche]')) {
          const lupe = document.querySelector('[data-mhsys-suche-auf]');
          menueTippMelden('suchfeld', 'feld', 'Suchfeld angetippt');
          sucheAusMenue = true;
          this.zu();
          if (lupe) lupe.click();
          return;
        }
        if (e.target.closest('[data-mhsys-menue-zu]')) {
          e.preventDefault();
          this.zu();
          return;
        }
        if (!e.target.closest('.mhsys-menue__panel')) this.zu();
      });

      /* Escape geht erst eine Ebene zurueck, auf der obersten schliesst es das Menue (Roadmap 4.4) */
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.menue.classList.contains('is-offen')) return;
        if (this.offeneEbene()) this.ebeneZu();
        else this.zu();
      });

      /* Im Leerlauf nachladen, damit das erste Antippen sofort etwas zeigt (03 Abschnitt 25) */
      if ('requestIdleCallback' in window) requestIdleCallback(() => this.laden(), { timeout: 4000 });
      else setTimeout(() => this.laden(), 2500);
    }

    laden() {
      if (this.geladen || this.laedt || !this.ziel) return Promise.resolve();
      this.laedt = true;
      /* Der aktuelle Pfad sorgt dafuer, dass link.current und child_active stimmen */
      const url = `${window.location.pathname}?section_id=mhsys-menue-liste`;
      return fetch(url)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const liste = doc.querySelector('[data-mhsys-menue-inhalt]');
          if (!liste) return;
          this.ziel.replaceChildren(document.adoptNode(liste));
          this.ziel.removeAttribute('aria-busy');
          this.geladen = true;
          this.aufklappenVerbinden();
          /* Vorbereiten: das Menue bleibt ab jetzt im Layout, geschlossen nur unsichtbar (visibility, siehe
             mhsys-weissblau.css). Das erste Sichtbarmachen von 590 Knoten kostete 189 ms Stil und Layout bei
             CPU x 4 - jetzt faellt das hier im Leerlauf an und nicht im Tipp aufs Menue. */
          this.menue.hidden = false;
          this.zustandAnwenden();
        })
        .catch((e) => console.error('Menü laden:', e))
        .finally(() => (this.laedt = false));
    }

    /* Ebenen statt Aufklappen (Roadmap 4.4, Wunsch des Inhabers 21.09.2026: "nicht gut erkennbar, in welcher
       Ebene man ist"). Die ganze Zeile (seit 29.10.2026, vorher nur der Pfeil) schiebt die Unterebene ueber die
       Liste; sie hat oben eine Kopfzeile mit Zurueck-Pfeil, dem Namen der Ebene und darueber, woher man kommt.
       Punkte ohne Unterpunkte sind echte Links und schliessen das Menue.
       Es gibt genau eine Schiebe-Ebene (Ebene 2); Ebene 3 steht dort schon aufgeklappt (Roadmap 4.8).
       Aufbau: die Ebene liegt absolut ueber der Liste - auf deren aktueller Scrollhoehe, so springt dahinter
       nichts. Die Liste steht so lange still (is-verdeckt), alles Verdeckte ist inert (Tastatur und
       Screenreader bleiben in der sichtbaren Ebene). */
    aufklappenVerbinden() {
      this.ziel.querySelectorAll('[data-mhsys-auf]').forEach((knopf) => {
        knopf.addEventListener('click', () => {
          const ebene = this.ziel.querySelector(`#${knopf.getAttribute('aria-controls')}`);
          if (ebene) this.ebeneAuf(ebene, true);
        });
      });
      this.ziel.querySelectorAll('[data-mhsys-zurueck]').forEach((knopf) => {
        knopf.addEventListener('click', () => this.ebeneZu());
      });
      /* Ebene 3 klappt in der Ebene an Ort und Stelle auf (Roadmap 4.8): Pfeil (und Name ohne eigene Seite)
         schalten die Liste darunter, beide halten ihr aria-expanded gleich; mehrere duerfen offen sein */
      this.ziel.querySelectorAll('[data-mhsys-klapp]').forEach((knopf) => {
        knopf.addEventListener('click', () => {
          const id = knopf.getAttribute('aria-controls');
          const liste = this.ziel.querySelector(`#${id}`);
          if (!liste) return;
          const auf = liste.hidden;
          liste.hidden = !auf;
          this.ziel.querySelectorAll(`[data-mhsys-klapp][aria-controls="${id}"]`).forEach((k) => {
            k.setAttribute('aria-expanded', auf ? 'true' : 'false');
          });
        });
      });
      this.ziel.querySelectorAll('[data-mhsys-menue-link]').forEach((link) => {
        link.addEventListener('click', () => this.zu());
      });
      this.tippsZaehlen();
      /* Nach rechts wischen = eine Ebene zurueck (deutlich waagerecht, mindestens 70 px) */
      let start = null;
      this.ziel.addEventListener(
        'touchstart',
        (e) => {
          start = this.offeneEbene() && e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
        },
        { passive: true }
      );
      this.ziel.addEventListener(
        'touchend',
        (e) => {
          if (!start) return;
          const dx = e.changedTouches[0].clientX - start.x;
          const dy = e.changedTouches[0].clientY - start.y;
          start = null;
          if (dx > 70 && Math.abs(dy) < dx * 0.6) this.ebeneZu();
        },
        { passive: true }
      );
    }

    /* Zaehlung (menueTippMelden oben): welcher Bereich geoeffnet wird und ob es danach mit "Alles aus ..." oder einem
       Unterpunkt weitergeht. Knopf ist der Handle des Hauptpunkts (nicht der einzelne Unterpunkt), so bleibt es bei gut
       fuenfzig Kennungen. Capture: vor den Horchern der Knoepfe, damit eine Gruppe noch ihren alten Zustand hat (nur das
       Aufklappen zaehlt). */
    tippsZaehlen() {
      const melden = menueTippMelden;
      const bereich = (ebene) => [
        ebene.dataset.mhsysMenueSchluessel,
        (ebene.querySelector('.mhsys-menue__ebenenname') || {}).textContent,
      ];
      const pfadEnde = (a) => (a.getAttribute('href') || '').split(/[?#]/)[0].replace(/\/+$/, '').split('/').pop() || 'start';
      this.ziel.addEventListener(
        'click',
        (e) => {
          const el = e.target.closest('a, button');
          if (!el || !this.ziel.contains(el) || (window.Shopify && window.Shopify.designMode)) return;
          if (el.hasAttribute('data-mhsys-zurueck')) return;
          if (el.hasAttribute('data-mhsys-auf')) {
            const ebene = this.ziel.querySelector(`#${el.getAttribute('aria-controls')}`);
            if (ebene) melden(el.classList.contains('mhsys-menue__kachel') ? 'schnell' : 'bereich', ...bereich(ebene));
            return;
          }
          const ebene = el.closest('[data-mhsys-ebene]');
          if (ebene) {
            if (el.hasAttribute('data-mhsys-klapp')) {
              if (el.getAttribute('aria-expanded') !== 'true') melden('gruppe', ...bereich(ebene));
            } else if (el.tagName === 'A') {
              melden(el.classList.contains('mhsys-menue__alle') ? 'alle' : 'unterpunkt', ...bereich(ebene));
            }
            return;
          }
          if (el.tagName !== 'A') return;
          const text = (el.querySelector('.mhsys-menue__name, .mhsys-menue__kachel-text, b') || el).textContent;
          if (el.classList.contains('mhsys-menue__zeile')) melden('direkt', pfadEnde(el), text);
          else if (el.classList.contains('mhsys-menue__kachel') || el.classList.contains('mhsys-menue__saison')) melden('schnell', pfadEnde(el), text);
          else if (el.classList.contains('mhsys-menue__dienst')) melden('service', pfadEnde(el), text);
        },
        true
      );
    }

    offeneEbene() {
      return this.ziel.querySelector('.mhsys-menue__ebene:not([hidden])');
    }

    ebeneAuf(ebene, mitFokus) {
      /* Es ist immer nur eine Ebene offen */
      const vorher = this.offeneEbene();
      if (vorher && vorher !== ebene) vorher.hidden = true;
      ebene.style.top = `${this.ziel.scrollTop}px`;
      this.ziel.classList.add('is-verdeckt');
      ebene.hidden = false;
      ebene.scrollTop = 0;
      this.ziel.querySelectorAll(`[data-mhsys-auf][aria-controls="${ebene.id}"]`).forEach((k) => {
        k.setAttribute('aria-expanded', 'true');
      });
      /* inert, Merken und Fokus erst nach dem ersten Bild: inert rechnet die Stile der ganzen Liste neu
         (176-208 ms im Tipp bei CPU x 4, Messung 21.09.2026) - im Klick bleibt nur das Sichtbarmachen */
      nachDemBild(() => {
        if (ebene.hidden) return;
        this.verdecken();
        this.zustandMerken();
        if (mitFokus) {
          const zurueck = ebene.querySelector('[data-mhsys-zurueck]');
          if (zurueck) zurueck.focus({ preventScroll: true });
        }
      });
    }

    ebeneZu() {
      const ebene = this.offeneEbene();
      if (!ebene) return;
      ebene.hidden = true;
      this.ziel.classList.remove('is-verdeckt');
      this.ziel.querySelectorAll(`[data-mhsys-auf][aria-controls="${ebene.id}"]`).forEach((k) => {
        k.setAttribute('aria-expanded', 'false');
      });
      /* Fokus zurueck auf den Pfeil der Zeile - oder auf die Kachel, wenn der Punkt in der Liste ausgeblendet ist */
      const pfeil =
        this.ziel.querySelector(`.mhsys-menue__auf[aria-controls="${ebene.id}"]`) ||
        this.ziel.querySelector(`[data-mhsys-auf][aria-controls="${ebene.id}"]`);
      nachDemBild(() => {
        this.verdecken();
        this.zustandMerken();
        if (pfeil) pfeil.focus({ preventScroll: true });
      });
    }

    /* Alles ausser der offenen Ebene inert: vom Ebenenknoten bis zur Liste hinauf die Geschwister */
    verdecken() {
      this.ziel.querySelectorAll('[inert]').forEach((el) => (el.inert = false));
      let kind = this.offeneEbene();
      while (kind && kind !== this.ziel) {
        const vater = kind.parentElement;
        for (const geschwister of vater.children) if (geschwister !== kind) geschwister.inert = true;
        kind = vater;
      }
    }

    /* Das Menue merkt sich, wie es stehen gelassen wurde - aufgeklappte Punkte und Scrollposition,
       ueber Seitenwechsel hinweg (Wunsch des Inhabers, 18.09.2026). Schluessel ist der Pfad der
       Menuepunkte (data-mhsys-menue-schluessel, Handle), nicht die Position: ein neuer Punkt im
       Menue verschiebt sonst alle gemerkten Zustaende. sessionStorage kann fehlen/werfen. */
    zustandLesen() {
      try {
        return JSON.parse(sessionStorage.getItem('mhsysMenue') || '{}') || {};
      } catch (e) {
        return {};
      }
    }

    zustandMerken() {
      if (!this.geladen) return;
      const offen = [...this.ziel.querySelectorAll('[data-mhsys-menue-schluessel]:not([hidden])')].map(
        (el) => el.dataset.mhsysMenueSchluessel
      );
      try {
        sessionStorage.setItem('mhsysMenue', JSON.stringify({ offen, scroll: Math.round(this.ziel.scrollTop) }));
      } catch (e) {
        /* ohne Speicher eben ohne Gedaechtnis */
      }
    }

    zustandAnwenden() {
      const zustand = this.zustandLesen();
      const offen = Array.isArray(zustand.offen) ? zustand.offen : [];
      /* Das Panel ist jetzt im Layout (auch geschlossen), scrollTop wirkt also schon hier - erst die Liste,
         dann die gemerkte Ebene (gemerkte Schluessel alter Staende mit "/", die dritte Ebene, gibt es nicht mehr) */
      if (zustand.scroll) this.ziel.scrollTop = zustand.scroll;
      const ebene = [...this.ziel.querySelectorAll('[data-mhsys-menue-schluessel]')].find((el) =>
        offen.includes(el.dataset.mhsysMenueSchluessel)
      );
      if (ebene) this.ebeneAuf(ebene, false);
    }

    /* Im Klick selbst nur das Noetigste (INP): sichtbar machen und Klasse setzen - das Einfahren startet
       ueber @starting-style in mhsys-weissblau.css, ohne erzwungenen Reflow. Vorher lagen hier Scroll-Sperre,
       offsetWidth, scrollTop und Fokus in einem Klick: 150 ms Selbstzeit bei CPU x 4 (Messung Enna). Der
       Rest folgt nach dem ersten Bild; das Panel steht dann noch fast ganz ausserhalb, ein Sprung der
       Scrollposition ist nicht zu sehen. */
    auf(ausloeser) {
      this.laden();
      this.menue.hidden = false;
      this.menue.classList.add('is-offen');
      this.letzterAusloeser = ausloeser;
      if (ausloeser) ausloeser.setAttribute('aria-expanded', 'true');
      nachDemBild(() => {
        if (!this.menue.classList.contains('is-offen')) return;
        document.documentElement.classList.add('mhsys-overlay-offen');
        if (this.geladen && !this.offeneEbene()) this.ziel.scrollTop = this.zustandLesen().scroll || 0;
        if (this.falleLoesen) this.falleLoesen(true);
        this.falleLoesen = fokusFalle(this.panel, ausloeser);
      });
    }

    zu() {
      if (!this.menue.classList.contains('is-offen')) return;
      this.zustandMerken();
      this.menue.classList.remove('is-offen');
      document.querySelectorAll('[data-mhsys-menue-auf]').forEach((k) => k.setAttribute('aria-expanded', 'false'));
      if (this.falleLoesen) this.falleLoesen();
      else if (this.letzterAusloeser) this.letzterAusloeser.focus();
      this.falleLoesen = null;
      scrollSperreLoesen();
      /* Geladen bleibt es vorbereitet im Layout (unsichtbar); nur vor dem Laden wieder ganz weg */
      setTimeout(() => {
        if (!this.geladen && !this.menue.classList.contains('is-offen')) this.menue.hidden = true;
      }, 300);
    }
  }

  /* --------------------------------------------------- Suche ohne Treffer */
  /* Suchen, die nichts finden, an mhsys melden (Roadmap 3.59 Paket B; mhsys docs/module/suche.md, Paket A Jonte):
       POST /apps/kunde?bereich=suche              {begriff, ort: 'vorschlag'|'seite', _dauer}   nur bei 0 Treffern
       POST /apps/kunde?bereich=suche&teil=zaehler {_dauer}                                     jede Suche, OHNE Begriff
     Der Zaehler macht den Anteil ohne Treffer sichtbar. Beides einmal je Begriff und Sitzung (sessionStorage) und
     verzoegert: erst wenn der Begriff eine Weile steht - sonst meldete jeder halb getippte Anfang ("Bre", "Brez").
     Ein Begriff mit @ oder mit mehr als sechs Ziffern am Stueck (Bestell-, Telefonnummer) verlaesst den Browser gar
     nicht erst; mhsys wiese ihn ohnehin ab. Fehler bleiben still - die Suche selbst haengt nicht daran.
     Aufgerufen von der Vorschlagsliste (unten) und der Suchseite (sections/mhsys-suchseite.liquid). */
  const suchmeldung = (() => {
    const SPEICHER = 'mhsysSucheGemeldet';
    const geladen = Date.now();
    let uhr = 0;
    const liste = () => {
      try { return JSON.parse(sessionStorage.getItem(SPEICHER) || '[]'); } catch (e) { return []; }
    };
    /* true, wenn der Schluessel neu war (und jetzt gemerkt ist); ohne sessionStorage wird nie gemeldet */
    const erstesMal = (schluessel) => {
      try {
        const l = liste();
        if (l.includes(schluessel)) return false;
        l.push(schluessel);
        sessionStorage.setItem(SPEICHER, JSON.stringify(l.slice(-200)));
        return true;
      } catch (e) {
        return false;
      }
    };
    const senden = (teil, rumpf) => {
      rumpf._dauer = Date.now() - geladen;
      return fetch('/apps/kunde?bereich=suche' + (teil ? '&teil=' + teil : ''), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(rumpf),
        credentials: 'same-origin',
        keepalive: true,
      }).catch(() => {});
    };
    const melden = (begriff, ort, treffer) => {
      const b = String(begriff || '').trim();
      if (b.length < 3 || b.length > 100) return;
      if (b.includes('@') || /\d{7,}/.test(b.replace(/[\s\-\/.]/g, ''))) return;
      const k = b.toLowerCase().replace(/\s+/g, ' ');
      if (erstesMal('z:' + k)) senden('zaehler', {});
      if (treffer === 0 && erstesMal('m:' + k)) senden('', { begriff: b, ort });
    };
    return {
      /* Melden, sobald der Begriff "ms" lang steht; ein neuer Aufruf ersetzt den alten */
      spaeter(begriff, ort, treffer, ms) {
        clearTimeout(uhr);
        uhr = setTimeout(() => melden(begriff, ort, treffer), ms);
      },
      abbrechen() {
        clearTimeout(uhr);
      },
    };
  })();
  window.mhsysSuchmeldung = suchmeldung;

  /* ------------------------------------------------- Passt der Treffer? */
  /* Shopify fuellt eine Suche, zu der es nichts Gutes findet, mit beliebigen Produkten auf (Befund 06.10.2026:
     "Strampler" -> Salami-Trommel, "Kapuzenpulli" -> Haftnotizen, "Krampus" -> Kinderbuecher). Der Kunde sieht dann
     scheinbar Treffer, und der Begriff landet nie in der Liste ohne Treffer in mhsys. Darum prueft das Theme selbst:
     ein Treffer passt, wenn eines der Suchwoerter (ab 3 Zeichen) in Name, Produktart, Tags, Hersteller, Varianten oder
     dem Anfang der Beschreibung vorkommt - als Teil eines Worts, mit gleichem Grundwort (Weihnachts-kugel /
     Christbaum-kugel) oder mit einem Tippfehler (1 ab 4 Zeichen, 2 ab 8: "tase" -> Tasse, "dirndel" -> Schwimmdirndl).
     Umlaute und ae/oe/ue gelten gleich, Bindestriche zaehlen mit und ohne ("t-shirt" = "tshirt").
     Geprueft an 66 Suchbegriffen gegen den Live-Shop: Unsinn faellt heraus, Tippfehler und Woerter aus der
     Beschreibung ("baumwolle") bleiben. Den Text je Treffer liefert das Liquid (data-mhsys-suche-text). */
  const sucheNorm = (t) => String(t || '').toLowerCase()
    .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
    .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u')
    .replace(/[^a-z0-9]+/g, ' ').trim();
  const sucheAbstand = (a, b, max) => {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    let vorher = Array.from({ length: b.length + 1 }, (_, i) => i);
    for (let i = 1; i <= a.length; i++) {
      const zeile = [i];
      let kleinste = i;
      for (let j = 1; j <= b.length; j++) {
        zeile[j] = Math.min(vorher[j] + 1, zeile[j - 1] + 1, vorher[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (zeile[j] < kleinste) kleinste = zeile[j];
      }
      if (kleinste > max) return max + 1;
      vorher = zeile;
    }
    return vorher[b.length];
  };
  const sucheWortPasst = (q, kette, liste) => {
    if (kette.includes(q)) return true;
    const max = q.length >= 8 ? 2 : q.length >= 4 ? 1 : 0;
    return liste.some((w) => {
      if (w.length >= 4 && q.includes(w)) return true;
      if (q.length >= 7 && w.length >= 7) {
        let n = 0;
        while (n < q.length && n < w.length && q[q.length - 1 - n] === w[w.length - 1 - n]) n++;
        if (n >= 5) return true;
      }
      if (!max) return false;
      for (let l = q.length - 1; l <= q.length + 1; l++) {
        if (l < 3 || l > w.length) continue;
        for (let i = 0; i + l <= w.length; i++) if (sucheAbstand(q, w.slice(i, i + l), max) <= max) return true;
      }
      return false;
    });
  };
  const suchePasst = (frage, text) => {
    const woerter = (t) => sucheNorm(t).split(' ').filter((w) => w.length >= 3);
    const fragen = Array.from(new Set(woerter(String(frage).replace(/[-‐]/g, '')).concat(woerter(frage))));
    if (!fragen.length) return true;
    const roh = String(text || '');
    const a = sucheNorm(roh);
    const b = sucheNorm(roh.replace(/[-‐]/g, ''));
    const kette = ` ${a} ${b} `;
    const liste = Array.from(new Set(`${a} ${b}`.split(' ').filter(Boolean)));
    return fragen.some((q) => sucheWortPasst(q, kette, liste));
  };
  window.mhsysSuchePasst = suchePasst;

  /* Aus der Suche geklickt (Panel, Suchseite, auch die Vorschlaege bei "nix gfunden"): der Handle kommt in
     sessionStorage mhsysSucheKlicks (hoechstens 20). Landet das Produkt in derselben Sitzung im Warenkorb, setzt
     assets/mhsys-quelle.js _quelle = suche - mhsys zaehlt es im Cockpit unter "Hat mitverkauft" (Messung 06.10.2026). */
  const sucheKlick = (link) => {
    const m = link && /\/products\/([^/?#]+)/.exec(link.getAttribute('href') || '');
    if (!m) return;
    try {
      const h = decodeURIComponent(m[1]);
      const l = JSON.parse(sessionStorage.getItem('mhsysSucheKlicks') || '[]').filter((x) => x !== h);
      l.push(h);
      sessionStorage.setItem('mhsysSucheKlicks', JSON.stringify(l.slice(-20)));
    } catch (e) {}
  };
  window.mhsysSucheKlick = sucheKlick;

  /* Zuletzt gesucht (Schritt D, 06.10.2026): localStorage mhsysZuletztGesucht, neueste zuerst, hoechstens sechs, gleiche
     Schreibweise (sucheSchluessel) nur einmal. Bleibt auf dem Geraet - nichts davon geht an den Shop oder an mhsys.
     Wie bei der Meldung ohne Treffer: kein Begriff mit @ oder mit sieben und mehr Ziffern (Bestell-, Telefonnummer). */
  const ZULETZT = 'mhsysZuletztGesucht';
  const zuletztLesen = () => {
    try {
      const l = JSON.parse(localStorage.getItem(ZULETZT) || '[]');
      return Array.isArray(l) ? l.filter((x) => typeof x === 'string').slice(0, 6) : [];
    } catch (e) {
      return [];
    }
  };
  const zuletztMerken = (begriff) => {
    const b = String(begriff || '').trim().replace(/\s+/g, ' ').slice(0, 60);
    if (b.length < 2 || b.includes('@') || /\d{7,}/.test(b.replace(/[\s\-/.]/g, ''))) return;
    try {
      const k = sucheSchluessel(b);
      const l = zuletztLesen().filter((x) => sucheSchluessel(x) !== k);
      l.unshift(b);
      localStorage.setItem(ZULETZT, JSON.stringify(l.slice(0, 6)));
    } catch (e) {}
  };
  window.mhsysSucheMerken = zuletztMerken;

  /* Such-Synonyme aus mhsys (Roadmap 3.59 Paket C, 06.10.2026): {begriff: {s: suchbegriff} | {p: handle}} aus dem
     Shop-Metafeld (sections/mhsys-kopf.liquid). Der Schluessel ist der Begriff wie in mhsys normalisiert
     (suche_begriff_normalisieren: klein, Umlaute ohne Punkte, ss, einfache Leerzeichen). */
  const sucheSchluessel = (t) => String(t || '').toLowerCase()
    .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss').replace(/[éè]/g, 'e')
    .replace(/\s+/g, ' ').trim();
  let sucheKarte = null;
  const sucheSynonym = (frage) => {
    if (sucheKarte === null) {
      sucheKarte = {};
      try {
        const roh = document.querySelector('[data-mhsys-suche-synonyme]');
        const k = roh ? JSON.parse(roh.textContent) : null;
        if (k && typeof k === 'object') sucheKarte = k;
      } catch (e) {}
    }
    const e = sucheKarte[sucheSchluessel(frage)];
    if (!e || typeof e !== 'object') return null;
    if (typeof e.p === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(e.p)) return { p: e.p };
    if (typeof e.s === 'string' && e.s.trim()) return { s: e.s.trim() };
    return null;
  };
  window.mhsysSucheSynonym = sucheSynonym;

  /* ---------------------------------------------------------------- Suche */
  class MhsysSuche {
    constructor(wurzel) {
      this.suche = wurzel;
      this.panel = wurzel.querySelector('.mhsys-suche__panel');
      this.eingabe = wurzel.querySelector('[data-mhsys-suche-eingabe]');
      this.ziel = wurzel.querySelector('[data-mhsys-suche-ziel]');
      this.label = wurzel.querySelector('[data-mhsys-suche-label]');
      this.chips = wurzel.querySelector('[data-mhsys-suche-chips]');
      this.leeren = wurzel.querySelector('[data-mhsys-suche-leeren]');
      this.block = wurzel.querySelector('[data-mhsys-suche-block]');
      this.beliebtUrl = wurzel.dataset.mhsysSucheBeliebt || '';
      this.anfrageNr = 0;
      this.zuletzt = wurzel.querySelector('[data-mhsys-suche-zuletzt]');

      document.querySelectorAll('[data-mhsys-suche-auf]').forEach((knopf) => {
        knopf.addEventListener('click', () => this.auf(knopf));
      });

      wurzel.addEventListener('click', (e) => {
        sucheKlick(e.target.closest('a[href*="/products/"]'));
        /* Wer einen Treffer, eine Kategorie oder "Alle Ergebnisse" antippt, hat gefunden - der Begriff kommt in
           "Zuletzt gesucht" (Schritt D) */
        if (e.target.closest('[data-mhsys-suche-ziel] a[href]')) {
          zuletztMerken(this.eingabe.value);
          if (this.ausMenue) menueTippMelden('suchfeld', 'treffer', 'Treffer gewählt');
          else if (this.offenGemeldet) shopTippMelden('kopf', 'lupe', 'treffer', 'danach Treffer gewählt');
          this.ausMenue = false;
          this.offenGemeldet = false;
        }
        if (e.target.closest('[data-mhsys-suche-zuletzt-weg]')) {
          try { localStorage.removeItem(ZULETZT); } catch (x) {}
          this.zuletztZeigen('');
          this.eingabe.focus();
          return;
        }
        /* "Frag Leni & Gustl" bei nix gfunden: Panel zu, den Chat oeffnet assets/mhsys-chat.js (Klick am document) */
        if (e.target.closest('[data-mhsys-gustl-oeffnen]')) {
          this.zu();
          return;
        }
        if (e.target.closest('[data-mhsys-suche-zu]')) {
          e.preventDefault();
          this.zu();
          return;
        }
        const chip = e.target.closest('[data-mhsys-suche-chip]');
        if (chip) {
          this.eingabe.value = chip.dataset.mhsysSucheChip;
          this.eingabe.focus();
          this.cursorAnsEnde();
          this.suchen();
          return;
        }
        if (!e.target.closest('.mhsys-suche__panel')) this.zu();
      });

      if (this.leeren) {
        this.leeren.addEventListener('click', () => {
          this.eingabe.value = '';
          this.eingabe.focus();
          this.suchen();
        });
      }

      /* Enter: zugeordnetes Produkt direkt oeffnen, ein Synonym gleich als Suchbegriff (von = was getippt war) */
      const formular = this.eingabe.form;
      if (formular) {
        formular.addEventListener('submit', (e) => {
          const frage = (this.eingabe.value || '').trim();
          zuletztMerken(frage);
          if (this.ausMenue && frage) menueTippMelden('suchfeld', 'abgeschickt', 'Suche abgeschickt');
          else if (this.offenGemeldet && frage) shopTippMelden('kopf', 'lupe', 'abgeschickt', 'danach Suche abgeschickt');
          this.ausMenue = false;
          this.offenGemeldet = false;
          const syn = frage && sucheSynonym(frage);
          if (!syn) return;
          e.preventDefault();
          window.location.href = syn.p
            ? `/products/${encodeURIComponent(syn.p)}`
            : `${formular.getAttribute('action') || '/search'}?q=${encodeURIComponent(syn.s)}&von=${encodeURIComponent(frage)}` +
              '&type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=show';
        });
      }

      this.eingabe.addEventListener('input', () => {
        clearTimeout(this.warten);
        this.warten = setTimeout(() => this.suchen(), 250);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.zu();
      });

      /* Pfeiltasten (Schritt D, am Rechner): aus dem Feld nach unten in Kategorien, Treffer und "Alle Ergebnisse",
         dort hoch und runter, ganz oben wieder ins Feld. Enter auf einem Treffer oeffnet ihn (es sind Links). */
      this.panel.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        const ziele = Array.from(this.ziel.querySelectorAll('a.mhsys-suche__kategorie, a.mhsys-suche__treffer-zeile, a.mhsys-suche__alle, a.mhsys-suche__kachel'))
          .filter((a) => a.offsetParent !== null);
        if (!ziele.length) return;
        const hier = ziele.indexOf(document.activeElement);
        if (document.activeElement === this.eingabe) {
          if (e.key !== 'ArrowDown') return;
          e.preventDefault();
          ziele[0].focus();
        } else if (hier >= 0) {
          e.preventDefault();
          const neu = hier + (e.key === 'ArrowDown' ? 1 : -1);
          if (neu < 0) this.eingabe.focus();
          else ziele[Math.min(neu, ziele.length - 1)].focus();
        }
      });

      /* Vorbereiten wie beim Menue: im Leerlauf ins Layout, geschlossen unsichtbar (erstes Oeffnen kostete
         51 ms Stil und Layout bei CPU x 4) */
      const vorbereiten = () => {
        if (!this.offen()) this.suche.hidden = false;
      };
      if ('requestIdleCallback' in window) requestIdleCallback(vorbereiten, { timeout: 4000 });
      else setTimeout(vorbereiten, 2500);
    }

    offen() {
      return this.suche.classList.contains('is-offen');
    }

    /* Cursor hinter den letzten Buchstaben (Inhaber 06.10.2026: beim Wiederoeffnen stand er am Anfang, Chrome am Handy) -
       weitertippen statt erst ans Ende tippen */
    cursorAnsEnde() {
      const n = (this.eingabe.value || '').length;
      try {
        this.eingabe.setSelectionRange(n, n);
      } catch (e) {}
    }

    /* Desktop: das Panel steht knapp unter der Kopfleiste, wo immer die gerade ist (Infoleiste,
       gescrollt, klassisch oder ueber dem Hero) - vorher fest bei 92 px und damit ueber der Navi */
    ausrichten() {
      const leiste = document.querySelector('.mhsys-kopf__innen');
      if (!leiste) return;
      const oben = `${Math.max(12, Math.round(leiste.getBoundingClientRect().bottom) + 10)}px`;
      /* Nur bei Aenderung setzen - jede Zuweisung macht den Stil der Suche ungueltig, und focus() muss
         ihn danach im Tipp neu berechnen (INP) */
      if (oben !== this.oben) this.suche.style.setProperty('--mhsys-suche-oben', (this.oben = oben));
    }

    /* Wie beim Menue nur das Noetigste im Klick. Der Fokus aufs Eingabefeld bleibt hier: iOS oeffnet die
       Tastatur nur, wenn focus() noch im Tipp selbst passiert. preventScroll spart das Scrollen ins Bild.
       Das Panel hat keine Einblendung, der fruehere offsetWidth-Reflow war ohne Zweck. */
    auf(ausloeser) {
      this.ausrichten();
      this.suche.hidden = false;
      this.suche.classList.add('is-offen');
      this.letzterAusloeser = ausloeser;
      this.ausMenue = sucheAusMenue;
      this.offenGemeldet = !sucheAusMenue;
      sucheAusMenue = false;
      this.eingabe.focus({ preventScroll: true });
      this.cursorAnsEnde();
      if (ausloeser) ausloeser.setAttribute('aria-expanded', 'true');
      if (!this.geladen) this.suchen();
      else this.zuletztZeigen((this.eingabe.value || '').trim());
      this.tastaturFolgen();
      nachDemBild(() => {
        if (!this.offen()) return;
        document.documentElement.classList.add('mhsys-overlay-offen');
        if (this.falleLoesen) this.falleLoesen(true);
        this.falleLoesen = fokusFalle(this.panel, ausloeser, true);
      });
    }

    /* Am Handy steht das Suchfeld unten im Schuber, in Daumennaehe (Roadmap 1.78, Inhaber 08.10.2026, Idee 5). Die
       Tastatur verkleinert nur die sichtbare Flaeche (visualViewport), nicht das Fenster - ohne Ausgleich laege das
       Feld darunter. Deshalb endet der Schuber, solange er offen ist, ueber der Tastatur: --mhsys-tastatur ist der
       verdeckte Streifen unten, --mhsys-vv-oben der Versatz, um den iOS die Ansicht beim Tippen hochschiebt.
       Nur Werte am Element der Suche, nur bei Aenderung - kein Layout im Handler gelesen ausser visualViewport. */
    tastaturFolgen() {
      const vv = window.visualViewport;
      if (!vv || this.vvHorcht) return;
      this.vvHorcht = true;
      let alt = '';
      const setzen = () => {
        const handy = window.matchMedia('(max-width: 749px)').matches;
        const oben = handy && this.offen() ? Math.max(0, Math.round(vv.offsetTop)) : 0;
        const unten = handy && this.offen() ? Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)) : 0;
        const neu = oben + '/' + unten;
        if (neu === alt) return;
        alt = neu;
        this.suche.style.setProperty('--mhsys-vv-oben', oben + 'px');
        this.suche.style.setProperty('--mhsys-tastatur', unten + 'px');
        this.suche.classList.toggle('mhsys-suche--tastatur', unten > 0);
      };
      vv.addEventListener('resize', setzen);
      vv.addEventListener('scroll', setzen);
      this.tastaturSetzen = setzen;
      setzen();
    }

    zu() {
      if (!this.offen()) return;
      this.suche.classList.remove('is-offen');
      if (this.tastaturSetzen) this.tastaturSetzen();
      document.querySelectorAll('[data-mhsys-suche-auf]').forEach((k) => k.setAttribute('aria-expanded', 'false'));
      /* Vor dem ersten Bild wieder zu: die Falle gibt es noch nicht, der Fokus geht trotzdem zurueck */
      if (this.falleLoesen) this.falleLoesen();
      else if (this.letzterAusloeser) this.letzterAusloeser.focus();
      this.falleLoesen = null;
      scrollSperreLoesen();
    }

    suchen() {
      const frage = (this.eingabe.value || '').trim();
      if (this.leeren) this.leeren.classList.toggle('is-sichtbar', frage.length > 0);
      if (this.chips) this.chips.hidden = frage.length > 0;
      this.zuletztZeigen(frage);

      const nr = ++this.anfrageNr;
      /* Ohne Suchbegriff antwortet /search/suggest mit 422 - dann die Kollektion "Beliebte Produkte" */
      if (!frage && !this.beliebtUrl) {
        if (this.block) this.block.hidden = true;
        return Promise.resolve();
      }
      const basis = (window.mhsysShop && window.mhsysShop.suchvorschlagUrl) || '/search/suggest';
      /* Synonym: gesucht wird nach dem Ziel; zugeordnetes Produkt: dazu seine Zeile ganz oben */
      const syn = frage ? sucheSynonym(frage) : null;
      const such = syn && syn.s ? syn.s : frage;
      const direkt = syn && syn.p
        ? fetch(`/products/${encodeURIComponent(syn.p)}?section_id=mhsys-suchergebnis`).then((r) => (r.ok ? r.text() : '')).catch(() => '')
        : Promise.resolve('');
      const url = frage
        ? `${basis}?q=${encodeURIComponent(such)}` +
          /* Artikel ohne Bestand mitzeigen - sonst findet man Saisonartikel nicht (Inhaber 18.09.2026). Ans Ende stellt sie
             das Liquid (mhsys-suchergebnis), nicht Shopify: mit unavailable_products=last rutschten ausverkaufte Treffer
             hinter alles Aufgefuellte und aus den 8 Plaetzen - "Duschgel" fand keins der zehn (06.10.2026) */
          /* Seit 06.10.2026 auch Kategorien und Wortvorschlaege, je Art eigenes Limit (limit_scope=each) */
          '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
          '&resources[options][unavailable_products]=show' +
          '&section_id=mhsys-suchergebnis'
        : `${this.beliebtUrl}?section_id=mhsys-suchergebnis`;

      return Promise.all([fetch(url).then((r) => r.text()), direkt])
        .then(([html, direktHtml]) => {
          /* Veraltete Antwort verwerfen: bei schnellem Tippen ueberholen sich die Anfragen */
          if (nr < this.anfrageNr) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const treffer = doc.querySelector('[data-mhsys-suche-inhalt]');
          if (!treffer) return;
          this.ziel.replaceChildren(document.adoptNode(treffer));
          this.geladen = true;
          if (frage) this.pruefen(such);
          if (!frage) this.beliebtMerken();
          if (direktHtml) this.direktEinsetzen(direktHtml);
          const anzahl = this.ziel.querySelectorAll('[data-mhsys-suche-treffer]').length;
          /* Ohne Suchbegriff und ohne Produkte keine leere Ueberschrift */
          if (this.block) this.block.hidden = !frage && anzahl === 0;
          if (this.label) {
            this.label.textContent = frage ? `${anzahl} Treffer für „${frage}“` : 'Beliebte Produkte';
          }
          /* Suche ohne Treffer melden, wenn der Begriff 2,5 s steht (oben, suchmeldung) */
          if (frage) suchmeldung.spaeter(frage, 'vorschlag', anzahl, 2500);
          else suchmeldung.abbrechen();
        })
        .catch((e) => console.error('Suche:', e));
    }

    /* "Zuletzt gesucht" nur bei leerem Feld; Chips wie "Haeufig gesucht" (data-mhsys-suche-chip sucht beim Tipp) */
    zuletztZeigen(frage) {
      if (!this.zuletzt) return;
      const liste = frage ? [] : zuletztLesen();
      this.zuletzt.hidden = !liste.length;
      if (!liste.length) return;
      const ziel = this.zuletzt.querySelector('[data-mhsys-suche-zuletzt-liste]');
      ziel.replaceChildren(...liste.map((b) => {
        const k = document.createElement('button');
        k.type = 'button';
        k.className = 'mhsys-suche__chip mhsys-suche__chip--zuletzt';
        k.dataset.mhsysSucheChip = b;
        k.textContent = b;
        return k;
      }));
    }

    /* Treffer, die nicht passen (suchePasst oben), fliegen raus. Passt keiner, steht der leere Zustand da - die
       Zaehlung danach ergibt 0, der Begriff geht als Suche ohne Treffer an mhsys. */
    pruefen(frage) {
      /* Kategorien ebenso (Schritt B) - Shopify fuellt auch sie auf */
      this.ziel.querySelectorAll('[data-mhsys-suche-kategorie]').forEach((k) => {
        if (!suchePasst(frage, k.dataset.mhsysSucheText || k.textContent)) k.remove();
      });
      const kategorien = this.ziel.querySelector('[data-mhsys-suche-kategorien]');
      if (kategorien && !kategorien.children.length) kategorien.remove();
      const zeilen = Array.from(this.ziel.querySelectorAll('[data-mhsys-suche-treffer]'));
      const passend = zeilen.filter((z) => suchePasst(frage, z.dataset.mhsysSucheText || z.textContent));
      zeilen.forEach((z) => { if (!passend.includes(z)) z.remove(); });
      if (passend.length) return;
      const liste = this.ziel.querySelector('.mhsys-suche__treffer');
      if (liste) liste.replaceChildren();
      const alle = this.ziel.querySelector('.mhsys-suche__alle');
      if (alle) alle.remove();
      const leer = this.ziel.querySelector('[data-mhsys-suche-leer]');
      if (!leer) return;
      leer.hidden = false;
      const chips = leer.querySelector('[data-mhsys-suche-leer-chips]');
      const vorlage = this.chips && this.chips.querySelector('.mhsys-suche__chips');
      if (chips && vorlage) chips.replaceChildren(...Array.from(vorlage.children, (c) => c.cloneNode(true)));
      this.beliebtEinsetzen(leer);
    }


    /* Das zugeordnete Produkt (Such-Synonyme) ganz oben; steht es schon in der Liste, wandert es nach oben. Wo vorher
       "nix gfunden" stand, gibt es jetzt diesen einen Treffer. */
    direktEinsetzen(html) {
      const zeile = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mhsys-suche-direkt]');
      const liste = this.ziel.querySelector('.mhsys-suche__treffer');
      if (!zeile || !liste) return;
      const pfad = (a) => (a.getAttribute('href') || '').split('?')[0];
      liste.querySelectorAll('[data-mhsys-suche-treffer]').forEach((a) => { if (pfad(a) === pfad(zeile)) a.remove(); });
      liste.prepend(document.adoptNode(zeile));
      const leer = this.ziel.querySelector('[data-mhsys-suche-leer]');
      if (leer) leer.hidden = true;
    }

    /* Die Beliebten Produkte vom Oeffnen (leeres Feld) merken - sie fuellen spaeter den leeren Zustand */
    beliebtMerken() {
      const k = this.ziel.querySelector('.mhsys-suche__kacheln');
      if (k) this.beliebtKacheln = k.cloneNode(true);
    }

    beliebtEinsetzen(leer) {
      const platz = leer.querySelector('[data-mhsys-suche-leer-beliebt]');
      if (!platz) return;
      const einsetzen = () => {
        if (!this.beliebtKacheln || !platz.isConnected) return;
        const k = this.beliebtKacheln.cloneNode(true);
        /* Keine Treffer im Sinne der Zaehlung - sonst stuende "6 Treffer" ueber "nix gfunden" */
        k.querySelectorAll('[data-mhsys-suche-treffer]').forEach((a) => a.removeAttribute('data-mhsys-suche-treffer'));
        platz.appendChild(k);
        platz.hidden = false;
      };
      if (this.beliebtKacheln || !this.beliebtUrl) {
        einsetzen();
        return;
      }
      fetch(`${this.beliebtUrl}?section_id=mhsys-suchergebnis`)
        .then((r) => r.text())
        .then((html) => {
          const k = new DOMParser().parseFromString(html, 'text/html').querySelector('.mhsys-suche__kacheln');
          if (k) this.beliebtKacheln = k;
          einsetzen();
        })
        .catch(() => {});
    }
  }

  /* ------------------------------------------------------------ Konto-Menue */
  /* Personen-Symbol (Inhaber 26.09.2026). Ab 990 px ein Aufklapper unter dem Symbol: kein Schleier, keine Scroll-Sperre,
     schliesst beim Klick daneben, bei Esc und beim Scrollen (fest positioniert - der Kopf aendert beim Scrollen Lage und
     Hoehe, ein Nachfuehren muesste im Scroll-Handler Geometrie lesen). Darunter ein Bogen von unten mit Schleier,
     Scroll-Sperre und Fokusfalle wie Menue und Suche. Das Symbol ist ein echter Link (ohne JavaScript, Mittelklick):
     nur der normale Klick wird abgefangen. */
  class MhsysKonto {
    constructor(wurzel) {
      this.wurzel = wurzel;
      this.panel = wurzel.querySelector('[data-mhsys-konto-panel]');
      this.breit = window.matchMedia('(min-width: 990px)');

      document.addEventListener('click', (e) => {
        const auf = e.target.closest('[data-mhsys-konto-auf]');
        if (auf) {
          if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          e.preventDefault();
          if (this.offen()) this.zu();
          else this.auf(auf);
          return;
        }
        if (!this.offen()) return;
        if (e.target.closest('[data-mhsys-konto-zu]') || !e.target.closest('[data-mhsys-konto-panel]')) this.zu(true);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.offen()) this.zu();
      });

      /* Nur die Seite, nicht das Menue selbst (bei wenig Hoehe scrollt es in sich) */
      document.addEventListener('scroll', (e) => {
        if (this.offen() && !this.bogen && !(e.target instanceof Node && this.panel.contains(e.target))) this.zu(true);
      }, { capture: true, passive: true });

      /* Wechsel ueber die 990 px (Fenster drehen) mit offenem Menue: schliessen statt umbauen */
      const wechsel = () => {
        if (this.offen()) this.zu(true);
      };
      if (this.breit.addEventListener) this.breit.addEventListener('change', wechsel);
    }

    offen() {
      return this.wurzel.classList.contains('is-offen');
    }

    /* Rechte Kante des Aufklappers an der rechten Kante des Symbols, knapp darunter; nie naeher als 12 px am Rand */
    ausrichten() {
      const r = this.ausloeser.getBoundingClientRect();
      const breite = document.documentElement.clientWidth;
      this.wurzel.style.setProperty('--mhsys-konto-oben', `${Math.round(r.bottom) + 10}px`);
      this.wurzel.style.setProperty('--mhsys-konto-rechts', `${Math.max(12, Math.round(breite - r.right) - 4)}px`);
    }

    auf(ausloeser) {
      this.ausloeser = ausloeser;
      this.bogen = !this.breit.matches;
      if (!this.bogen) this.ausrichten();
      this.wurzel.classList.toggle('is-bogen', this.bogen);
      this.wurzel.hidden = false;
      this.wurzel.classList.add('is-offen');
      ausloeser.setAttribute('aria-expanded', 'true');
      if (this.bogen) this.panel.setAttribute('aria-modal', 'true');
      else this.panel.removeAttribute('aria-modal');
      this.panel.focus({ preventScroll: true });
      nachDemBild(() => {
        if (!this.offen()) return;
        if (this.bogen) document.documentElement.classList.add('mhsys-overlay-offen');
        if (this.falleLoesen) this.falleLoesen(true);
        this.falleLoesen = this.bogen ? fokusFalle(this.panel, ausloeser, true) : null;
      });
    }

    /* ohneFokus: Klick daneben oder Scrollen - der Fokus bleibt, wo der Kunde hingeklickt hat */
    zu(ohneFokus) {
      if (!this.offen()) return;
      this.wurzel.classList.remove('is-offen');
      this.wurzel.hidden = true;
      document.querySelectorAll('[data-mhsys-konto-auf]').forEach((k) => k.setAttribute('aria-expanded', 'false'));
      if (this.falleLoesen) this.falleLoesen(true);
      this.falleLoesen = null;
      if (!ohneFokus && this.ausloeser) this.ausloeser.focus();
      if (this.bogen) scrollSperreLoesen();
    }
  }

  /* ------------------------------------------------------------------ Start */
  /* Menue und Suche direkt an <body> haengen. In der Kopf-Section steckten sie im Stapelkontext
     des klebenden Kopfes (z-index 20) - ihr eigenes z-index 2147483001 galt nur darin, und der
     Shopify-Chat (2147483000) lag am Handy darueber (08 C6, Funktionstest 18.09.2026).
     Im Theme-Editor setzt Shopify den Kopf neu ein: die alte, schon verschobene Fassung wird entfernt. */
  function portieren(el, attr) {
    if (!el || el.parentElement === document.body) return;
    document.querySelectorAll(`body > [${attr}]`).forEach((alt) => alt.remove());
    document.body.appendChild(el);
  }

  /* Konto-Symbol angemeldet: Hut, Kranz oder Herz (Inhaber 26.09.2026). Die Wahl gehoert ins Kundenkonto: mhsys schreibt sie
     ueber den App-Proxy (bereich=konto&teil=figur) ins Kunden-Metafeld custom.konto_figur, layout/theme.liquid liest es
     (window.mhsysFigurCfg.konto) und setzt html[data-mhsys-figur] schon vor dem ersten Zeichnen. Im Browser steht die Wahl
     zusaetzlich (mhsysFigurWahl = {f, k, offen, t}): sie gilt sofort und bleibt, bis mhsys sie angenommen hat - ohne Proxy
     (privates Fenster, mhsys nicht erreichbar) geht nichts verloren. Ein Senden, das nicht ankam, wird beim naechsten
     Seitenaufruf wiederholt, hoechstens alle 10 Minuten. */
  const FIGUR_SPEICHER = 'mhsysFigurWahl';
  function figurPruefen(f) {
    return f === 'kranz' || f === 'herz' ? f : 'hut';
  }
  function figurLesen() {
    return figurPruefen(document.documentElement.getAttribute('data-mhsys-figur'));
  }
  function figurKnoepfe() {
    const figur = figurLesen();
    document.querySelectorAll('[data-mhsys-figur-wahl]').forEach((k) => {
      k.setAttribute('aria-pressed', String(k.dataset.mhsysFigurWahl === figur));
    });
  }
  function figurWahlLesen() {
    try {
      return JSON.parse(localStorage.getItem(FIGUR_SPEICHER) || 'null');
    } catch (err) {
      return null;
    }
  }
  function figurWahlSchreiben(w) {
    try {
      localStorage.setItem(FIGUR_SPEICHER, JSON.stringify(w));
      localStorage.removeItem('mhsysFigur');
    } catch (err) {}
  }
  function figurSenden(w) {
    const cfg = window.mhsysFigurCfg;
    if (!cfg || !cfg.proxy) return;
    w.versuch = Date.now();
    figurWahlSchreiben(w);
    fetch(cfg.proxy, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ figur: w.f }),
      credentials: 'same-origin',
    })
      .then((r) => r.json())
      .then((a) => {
        const jetzt = figurWahlLesen();
        /* In der Zwischenzeit neu gewaehlt: diese Antwort gilt nicht mehr */
        if (!a || !a.ok || !jetzt || jetzt.f !== w.f || jetzt.k !== w.k) return;
        jetzt.offen = false;
        jetzt.t = Date.now();
        figurWahlSchreiben(jetzt);
      })
      .catch(() => {});
  }
  /* Beim Laden: eine offene Wahl (auch die aus der Zeit vor dem Konto, mhsysFigur) nachsenden; sonst den Stand des Kontos
     im Browser nachziehen, damit eine alte Wahl nicht wieder auftaucht, wenn das Konto sie einmal nicht liefert */
  function figurAbgleichen() {
    const cfg = window.mhsysFigurCfg;
    if (!cfg) return;
    let w = figurWahlLesen();
    if (!w) {
      let alt = null;
      try {
        alt = localStorage.getItem('mhsysFigur');
      } catch (err) {}
      if (alt) w = { f: figurPruefen(alt), k: cfg.kunde, offen: true, t: 0 };
    }
    if (w && w.k === cfg.kunde && (w.offen || !cfg.konto)) {
      if (!w.versuch || Date.now() - w.versuch > 600000) figurSenden(w);
      return;
    }
    if (cfg.konto && (!w || w.k !== cfg.kunde || (w.f !== cfg.konto && Date.now() - (w.t || 0) >= 60000))) {
      figurWahlSchreiben({ f: cfg.konto, k: cfg.kunde, offen: false, t: 0 });
    }
  }
  document.addEventListener('click', (e) => {
    const k = e.target.closest('[data-mhsys-figur-wahl]');
    if (!k) return;
    const figur = figurPruefen(k.dataset.mhsysFigurWahl);
    if (figur !== 'hut') document.documentElement.setAttribute('data-mhsys-figur', figur);
    else document.documentElement.removeAttribute('data-mhsys-figur');
    figurKnoepfe();
    const cfg = window.mhsysFigurCfg;
    if (cfg) figurSenden({ f: figur, k: cfg.kunde, offen: true, t: Date.now() });
  });
  figurAbgleichen();

  function starten() {
    document.querySelectorAll('[data-mhsys-kopf]').forEach((el) => {
      if (!el.dataset.mhsysBereit) {
        el.dataset.mhsysBereit = '1';
        new MhsysKopf(el);
      }
    });
    const menue = document.querySelector('[data-mhsys-menue]');
    portieren(menue, 'data-mhsys-menue');
    if (menue && !menue.dataset.mhsysBereit) {
      menue.dataset.mhsysBereit = '1';
      new MhsysMenue(menue);
    }
    const suche = document.querySelector('[data-mhsys-suche]');
    portieren(suche, 'data-mhsys-suche');
    if (suche && !suche.dataset.mhsysBereit) {
      suche.dataset.mhsysBereit = '1';
      new MhsysSuche(suche);
    }
    const konto = document.querySelector('[data-mhsys-konto]');
    portieren(konto, 'data-mhsys-konto');
    if (konto && !konto.dataset.mhsysBereit) {
      konto.dataset.mhsysBereit = '1';
      new MhsysKonto(konto);
    }
    figurKnoepfe();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', shopKlicksZaehlen);
  else shopKlicksZaehlen();

  /* Im Theme-Editor wird der Kopf nach jeder Aenderung neu eingesetzt */
  document.addEventListener('shopify:section:load', starten);
})();
